<template>
    <layout>
        <template #header>
            <div class="row align-items-end">
                <h2 class="title ml-4 mb-0">Returns </h2>
                <span class="ml-3 font-weight-bold">{{ mtd.company_name }} - {{ mtd.name }}</span>
            </div>
            <AppHead :title="'Returns - ' + mtd.company_name" />
            <flash-messages />
        </template>

        <div class="bg-white p-3 pb-0">
            <div class="m-1 mb-3">
                <a :href="route('mtd.view', mtdId)"><i class="fa-solid fa-arrow-left"></i> Back to MTD</a>
            </div>
            <ReturnsUserDashboard :mtdId="mtdId" isAdminView="true" />
        </div>
    </layout>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import FlashMessages from '@/Shared/FlashMessages'
import ReturnsUserDashboard from '@/Components/Returns/ReturnsUserDashboard.vue';

export default {
    components: {
        Layout,
        FlashMessages,
        ReturnsUserDashboard,
    },
    props: {
        mtdId: Number,
        mtd: Object,
    },
    methods: {
    },
}

</script>